export default "__VITE_ASSET__401b9d5f__"